import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function PerguntaRespostaItemComponent(props) {
  return (
    <div className="d-flex flew-column flex-wrap mt-3 col" id={`Ticket_${props.id}`} key={`Ticket_${props.id}`}>
      <div className="col-12 fw-light w-100" style={{ fontSize: "smaller" }}>
        {props.pergunta}
      </div>
      <div className="d-flex flew-row flex-nowrap mt-2 col12 align-items-start">
        <div className="ms-3" style={{ transform: "translate(0px, -2px)" }}>
          <div className="border border-2 border-top-0 border-end-0" style={{ width: "14px", height: "14px" }}></div>
        </div>
        <div className="ms-2 fw-light col" style={{ fontSize: "smaller" }}>
          {props.resposta !== "" ? props.resposta : "Aguarde, em breve será respondida."}
        </div>
      </div>
    </div>
  );
}
